import { Dropdown } from "@/ds";
import { SECOES_MENU_SELECT_PREFIX } from "./secoes-menu.constants";
import styles from "./secoes-menu.module.scss";
import type { SecoesMenuViewModel } from "./types-secoes-menu";

export function SecoesMenuView({
  menuRef,
  isMobile,
  label,
  className,
  testId,
  selectTestId,
  activeId,
  itens,
  opcoes,
  selecionar,
  selecionarOpcao,
  protegerEsc,
}: SecoesMenuViewModel) {
  if (isMobile) {
    return (
      <div className={styles.seletor} onKeyDown={protegerEsc}>
        <Dropdown
          className={className}
          value={activeId}
          options={opcoes}
          onChange={selecionarOpcao}
          valueTemplate={(option) => (
            <span className={styles.selectValor}>
              <span className={styles.selectPrefixo}>{SECOES_MENU_SELECT_PREFIX}</span>
              {option?.label}
            </span>
          )}
          aria-label={label}
          data-testid={selectTestId}
        />
      </div>
    );
  }

  return (
    <nav
      ref={menuRef}
      className={className ? `${styles.menu} ${className}` : styles.menu}
      aria-label={label}
      data-testid={testId}
    >
      <ul className={styles.lista}>
        {itens.map((item) => (
          <li key={item.id}>
            <button
              type="button"
              className={item.ativo ? styles.itemAtivo : styles.item}
              aria-current={item.ariaCurrent}
              {...item.marcaAtivo}
              onClick={() => selecionar(item.id)}
              data-testid={item.testId}
            >
              {item.title}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
